// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__AHi3d","text":"styles_text__yEZHP","opening":"styles_opening__jHpcR","item":"styles_item__JNodi","h3":"styles_h3__rJrr7"};